import React, { useCallback } from "react";
import { MenuButton, MenuList } from "@ls/react-menu";
import styles from "./KebabMenu.module.css";
import Icon from "react-icons-kit";
import { ic_more_vert } from "react-icons-kit/md/ic_more_vert";
import Input from "@ls/react-input";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAppDecimal,
  selectAppTitle,
  selectBandedRows,
  selectDisableCustomGroupSort,
  selectDisableIntersperse,
  selectGridFontSize,
  selectGridHeaderHeight,
  selectGridRowHeight,
  selectGridVerticalLines,
  selectHideGridSideBar,
  selectListenScenarioAppTalk,
  selectLoadDataOnLaunch,
  selectListenEntityGroupAppTalk,
} from "state/app/selector";
import {
  setAppDecimal,
  setAppTitle,
  setBandedRows,
  setDisableCustomGroupSort,
  setDisableIntersperse,
  setGridFontSize,
  setGridHeaderHeight,
  setGridRowHeight,
  setGridVerticalLines,
  setHideGridSideBar,
  setListenScenarioAppTalk,
  setLoadDataOnLaunch,
  setListenEntityGroupAppTalk,
} from "state/app/actions";
import Checkbox from "@ls/react-checkbox";

const urlParams = new URLSearchParams(window.location.search);
const hideGridBarOption = urlParams.get("hideGridBarOption") === "true"; //asked by Doug

const KebabMenu = () => {
  const dispatch = useDispatch();
  const appTitle = useSelector(selectAppTitle);
  const appDecimal = useSelector(selectAppDecimal);
  const disableCustomGroupSort = useSelector(selectDisableCustomGroupSort);
  const disableIntersperse = useSelector(selectDisableIntersperse);
  const bandedRows = useSelector(selectBandedRows);
  const gridVerticalLines = useSelector(selectGridVerticalLines);
  const gridFontSize = useSelector(selectGridFontSize);
  const gridRowHeight = useSelector(selectGridRowHeight);
  const gridHeaderHeight = useSelector(selectGridHeaderHeight);
  const listenScenarioAppTalk = useSelector(selectListenScenarioAppTalk);
  const listenEntityGroupAppTalk = useSelector(selectListenEntityGroupAppTalk);
  const hideGridSideBar = useSelector(selectHideGridSideBar);
  const loadDataOnLaunch = useSelector(selectLoadDataOnLaunch);
  const onDecimalChange = useCallback(
    (val) => {
      dispatch(setAppDecimal(Number(val)));
    },
    [dispatch]
  );
  const onAppTitleChange = useCallback(
    (val) => {
      dispatch(setAppTitle(val));
    },
    [dispatch]
  );
  const onListenScenarioAppTalkChange = useCallback(
    (value) => {
      dispatch(setListenScenarioAppTalk(value));
    },
    [dispatch]
  );
  const onListenEntityGroupAppTalkChange = useCallback(
    (value) => {
      dispatch(setListenEntityGroupAppTalk(value));
    },
    [dispatch]
  );
  const onCustomGroupSortChange = useCallback(
    (value) => {
      dispatch(setDisableCustomGroupSort(!value));
    },
    [dispatch]
  );

  const onChangeIntersperse = useCallback(
    (value) => {
      dispatch(setDisableIntersperse(!value));
    },
    [dispatch]
  );

  const onBandedRowsChange = useCallback(
    (value) => {
      dispatch(setBandedRows(value));
    },
    [dispatch]
  );
  const onGridVerticalLinesChange = useCallback(
    (value) => {
      dispatch(setGridVerticalLines(value));
    },
    [dispatch]
  );
  const onGridFontSizeChange = useCallback(
    (val) => {
      dispatch(setGridFontSize(Number(val)));
    },
    [dispatch]
  );
  const onGridRowHeightChange = useCallback(
    (val) => {
      dispatch(setGridRowHeight(Number(val)));
    },
    [dispatch]
  );
  const onGridHeaderHeightChange = useCallback(
    (val) => {
      dispatch(setGridHeaderHeight(Number(val)));
    },
    [dispatch]
  );
  const onChangeHideSideBar = useCallback(
    (val) => {
      dispatch(setHideGridSideBar(!val));
    },
    [dispatch]
  );
  const onChangeLoadDataOnLaunch = useCallback(
    (val) => {
      dispatch(setLoadDataOnLaunch(!val));
    },
    [dispatch]
  );

  return (
    <MenuButton
      buttonVariation={5}
      menuList={
        <MenuList>
          <div className={styles.item}>
            <Checkbox
              label={"Listen for Entity group AppTalk Messages"}
              value={listenEntityGroupAppTalk}
              onChange={onListenEntityGroupAppTalkChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Listen for Scenario AppTalk Messages"}
              value={listenScenarioAppTalk}
              onChange={onListenScenarioAppTalkChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Load without an account"}
              value={!loadDataOnLaunch}
              onChange={onChangeLoadDataOnLaunch}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Apply custom group row order"}
              value={!disableCustomGroupSort}
              onChange={onCustomGroupSortChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Intersperse Columns"}
              value={!disableIntersperse}
              onChange={onChangeIntersperse}
            />
          </div>
          {!hideGridBarOption && (
            <div className={styles.item}>
              <Checkbox
                label={"Show Grid Side Bar"}
                value={!hideGridSideBar}
                onChange={onChangeHideSideBar}
              />
            </div>
          )}
          <div className={styles.item}>
            <Checkbox
              label={"Show Banded Rows"}
              value={bandedRows}
              onChange={onBandedRowsChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Show Vertical Lines"}
              value={gridVerticalLines}
              onChange={onGridVerticalLinesChange}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Grid font size:"}
              value={gridFontSize}
              size={"S"}
              onChange={onGridFontSizeChange}
              min={8}
              max={16}
              type={"number"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Grid header height:"}
              value={gridHeaderHeight}
              size={"S"}
              onChange={onGridHeaderHeightChange}
              min={0}
              max={150}
              type={"number"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Grid row height:"}
              value={gridRowHeight}
              size={"S"}
              onChange={onGridRowHeightChange}
              min={10}
              max={40}
              type={"number"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Default decimals:"}
              value={appDecimal}
              size={"S"}
              onChange={onDecimalChange}
              min={0}
              max={8}
              type={"number"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Title:"}
              size={"S"}
              value={appTitle}
              onChange={onAppTitleChange}
            />
          </div>
         
        </MenuList>
      }
      icon={<Icon icon={ic_more_vert} size={30} />}
      tooltip="Settings"
    />
  );
};

export default KebabMenu;
